<template>
  <div class="agwSearch">
    <Row>
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4" style="padding-right:10px">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['network:agwMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableAgw from "../agw/TableAgw";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
var tableAgw = TableAgw;
export default {
  name: "AgwMonitorSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      stateSearchKey: []
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      tableAgw.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.agwSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/agw/AgwMonitorSearch.vue